import { Icon, TIconNames } from 'components/Base/Icon';
import { Colors } from 'core/CssVariables';
import { EVia } from './ButtonGroup.type';

export const buttonGroupPropsMap = {
  [EVia.EMAIL]: {
    outlined: true,
    icon: (
      <Icon color={Colors.Black} icon={TIconNames.MOBILE_PHONE} size={16} />
    ),
  },
  [EVia.PHONE]: {
    icon: <Icon color={Colors.Black} icon={TIconNames.ENVELOPE} size={16} />,
  },
};
